import assertOkResponseCode from './assertOkResponseCode';

const config = {
  RATE_HOST: 'https://api.wise.com/v1/rates?source={SOURCE}&target={TARGET}',
  RATE_TOKEN:
    'OGNhN2FlMjUtOTNjNS00MmFlLThhYjQtMzlkZTFlOTQzZDEwOjliN2UzNmZkLWRjYjgtNDEwZS1hYzc3LTQ5NGRmYmEyZGJjZA==',
};

function fetchRate(source, target) {
  return fetch(config.RATE_HOST.replace(/{SOURCE}/, source).replace(/{TARGET}/, target), {
    headers: { 'Content-Type': 'application/json', Authorization: `Basic ${config.RATE_TOKEN}` },
    method: 'GET',
  })
    .then(assertOkResponseCode)
    .then((response) => response.json())
    .then((list) => ({ route: list[0] }));
}

export default fetchRate;
